import React, { useMemo } from "react";
import { Colors } from "../../utils/colors";
import { Strings } from "../../utils/strings";
import { TCText } from "../TCText/TCText";
import { observer } from "mobx-react-lite";
import {
  useCourtBookingStore,
  useSelectCircleStore,
} from "../../stores/StoreContext";
import { GUEST_PLAYERS } from "../../utils/data";

type props = {};

export const GuestPlayerCounter: React.FC<props> = observer(() => {
  const selectCircleStore = useSelectCircleStore();
  const courtBookingStore = useCourtBookingStore();

  // Get guest player index based on count, cycling through available guest players
  const guestPlayerIndex = useMemo(
    () => selectCircleStore.guestPlayerCount % GUEST_PLAYERS.length,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const decreaseCounterDisabled = selectCircleStore.guestPlayerCount === 0;
  const increaseCounterDisabled =
    selectCircleStore.selectedPlayers.length ===
    courtBookingStore.totalPlayersToSelect;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "12px 5px",
      }}>
      <div className="player-avatar">
        <img
          src={GUEST_PLAYERS[guestPlayerIndex].userImageUrl}
          alt=""
          className="player-image"
        />
      </div>
      <TCText
        className="player-name"
        style={{ flex: 1, marginLeft: 30 }}
        value={Strings.GUEST_PLAYER}
      />
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div
          onClick={
            decreaseCounterDisabled
              ? undefined
              : () => selectCircleStore.decrementGuestCount()
          }
          style={{
            cursor: "pointer",
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: decreaseCounterDisabled
              ? Colors.grey
              : Colors.darkBrown,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <TCText
            style={{
              color: "white",
              fontSize: 25,
              textAlign: "center",
            }}
            value="-"
          />
        </div>
        <TCText
          style={{ fontSize: 14, minWidth: 20, textAlign: "center" }}
          value={selectCircleStore.guestPlayerCount.toString()}
        />
        <div
          onClick={
            increaseCounterDisabled
              ? undefined
              : () => selectCircleStore.incrementGuestCount()
          }
          style={{
            cursor: "pointer",
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: increaseCounterDisabled
              ? Colors.grey
              : Colors.darkBrown,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <TCText
            style={{
              color: "white",
              fontSize: 22,
              textAlign: "center",
            }}
            value="+"
          />
        </div>
      </div>
    </div>
  );
});
